<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Good Time Coming</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<p class="epigraph">There’s a good time coming, boys.</p>
<p class="epigraph">A good time coming:</p>
<p class="epigraph">War in all men’s eyes shall be</p>
<p class="epigraph">A monster of iniquity</p>
<p class="epigraph">In the good time coming.</p>
<p class="epigraph">Nations shall not quarrel then,</p>
<p class="epigraph">To prove which is the stronger;</p>
<p class="epigraph">Nor slaughter men for glory’s sake;–</p>
<p class="epigraph-space-after">Wait a little longer.</p>
<p class="epigraph-source">The Good Time Coming, 1846,</p>
<p class="epigraph-source">words by Charles Mackay; melody by Stephen Foster.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0192301b